import React, { useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { useLocation } from "@reach/router"
import { Form, Container, Row, Col, Dropdown } from 'react-bootstrap';
import HTMLReactParser from "html-react-parser";
import { connectSortBy, connectStats } from "react-instantsearch-core";
import $ from "jquery";
import Filter from "../Filter/Filter";
import './FilterOption.scss';
import _ from "lodash";

export const bedroomOpts = [
    { label: "Min Beds", value: 0 },
    { label: "1+", value: 1 },
    { label: "2+", value: 2 },
    { label: "3+", value: 3 },
    { label: "4+", value: 4 },
    { label: "5+", value: 5 },
]

export const propertyTypeOpts = [
    { label: "Property Type", value: "" },
    { label: "Apartment", value: "apartment" },
    { label: "Office", value: "office" },
    { label: "House", value: "house" },
    { label: "Maisonette", value: "maisonette" }
]

export const priceminRangeSale = [
    {
        value: "",
        label: "No Min",
    },
    {
        value: "500000",
        label: "£ 500,000",
    },
    {
        value: "750000",
        label: "£ 750,000",
    },
    {
        value: "1000000",
        label: "£ 1,000,000",
    },
    {
        value: "1250000",
        label: "£ 1,250,000",
    },
    {
        value: "1500000",
        label: "£ 1,500,000",
    },
    {
        value: "2000000",
        label: "£ 2,000,000",
    },
    {
        value: "3000000",
        label: "£ 3,000,000",
    },
    {
        value: "5000000",
        label: "£ 5,000,000",
    },
]

export const pricemaxRangeSale = [
    {
        value: "",
        label: "No Max",
    },
    {
        value: "500000",
        label: "£ 500,000",
    },
    {
        value: "750000",
        label: "£ 750,000",
    },
    {
        value: "1000000",
        label: "£ 1,000,000",
    },
    {
        value: "1250000",
        label: "£ 1,250,000",
    },
    {
        value: "1500000",
        label: "£ 1,500,000",
    },
    {
        value: "2000000",
        label: "£ 2,000,000",
    },
    {
        value: "3000000",
        label: "£ 3,000,000",
    },
    {
        value: "5000000",
        label: "£ 5,000,000",
    },
    {
        value: "10000000",
        label: "£ 10,000,000",
    },
]


const priceminRangeRent = [
    {
        value: "",
        label: "No Min",
    },
    {
        value: "300",
        label: "£ 300 PW",
    },
    {
        value: "350",
        label: "£ 350 PW",
    },
    {
        value: "400",
        label: "£ 400 PW",
    },
    {
        value: "450",
        label: "£ 450 PW",
    },
    {
        value: "500",
        label: "£ 500 PW",
    },
    {
        value: "600",
        label: "£ 600 PW",
    },
    {
        value: "700",
        label: "£ 700 PW",
    },
    {
        value: "800",
        label: "£ 800 PW",
    },
    {
        value: "900",
        label: "£ 900 PW",
    },
    {
        value: "1000",
        label: "£ 1000 PW",
    },
    {
        value: "1100",
        label: "£ 1100 PW",
    },
    {
        value: "1200",
        label: "£ 1200 PW",
    },
    {
        value: "1300",
        label: "£ 1300 PW",
    },
    {
        value: "1400",
        label: "£ 1400 PW",
    },
    {
        value: "1500",
        label: "£ 1500 PW",
    },
    {
        value: "1600",
        label: "£ 1600 PW",
    },    
    {
        value: "1700",
        label: "£ 1700 PW",
    },
    {
        value: "1750",
        label: "£ 1750 PW",
    },
    {
        value: "2000",
        label: "£ 2000 PW",
    },
    {
        value: "2250",
        label: "£ 2250 PW",
    },
    {
        value: "2500",
        label: "£ 2500 PW",
    },
    {
        value: "2750",
        label: "£ 2750 PW",
    },
    {
        value: "3000",
        label: "£ 3000 PW",
    },
    {
        value: "3500",
        label: "£ 3500 PW",
    },
    {
        value: "4000",
        label: "£ 4000 PW",
    },
    {
        value: "4500",
        label: "£ 4500 PW",
    },
    {
        value: "5000",
        label: "£ 5000 PW",
    }
]


const pricemaxRangeRent = [
    {
        value: "",
        label: "No Max",
    },
    {
        value: "300",
        label: "£ 300 PW",
    },
    {
        value: "350",
        label: "£ 350 PW",
    },
    {
        value: "400",
        label: "£ 400 PW",
    },
    {
        value: "450",
        label: "£ 450 PW",
    },
    {
        value: "500",
        label: "£ 500 PW",
    },
    {
        value: "600",
        label: "£ 600 PW",
    },
    {
        value: "700",
        label: "£ 700 PW",
    },
    {
        value: "800",
        label: "£ 800 PW",
    },
    {
        value: "900",
        label: "£ 900 PW",
    },
    {
        value: "1000",
        label: "£ 1000 PW",
    },
    {
        value: "1100",
        label: "£ 1100 PW",
    },
    {
        value: "1200",
        label: "£ 1200 PW",
    },
    {
        value: "1300",
        label: "£ 1300 PW",
    },
    {
        value: "1400",
        label: "£ 1400 PW",
    },
    {
        value: "1500",
        label: "£ 1500 PW",
    },
    {
        value: "1600",
        label: "£ 1600 PW",
    },    
    {
        value: "1700",
        label: "£ 1700 PW",
    },
    {
        value: "1750",
        label: "£ 1750 PW",
    },
    {
        value: "2000",
        label: "£ 2000 PW",
    },
    {
        value: "2250",
        label: "£ 2250 PW",
    },
    {
        value: "2500",
        label: "£ 2500 PW",
    },
    {
        value: "2750",
        label: "£ 2750 PW",
    },
    {
        value: "3000",
        label: "£ 3000 PW",
    },
    {
        value: "3500",
        label: "£ 3500 PW",
    },
    {
        value: "4000",
        label: "£ 4000 PW",
    },
    {
        value: "4500",
        label: "£ 4500 PW",
    },
    {
        value: "5000",
        label: "£ 5000 PW",
    }
]

const TitleContainer = connectStats(({ nbHits, searchType, searchString, h1, search_area }) => {

  const data = useStaticQuery(graphql`
        query {
            glstrapi {
                siteConfig {
                   Search_Intro {
                        Slug
                        Intro_Content
                        id
                   }
                }  
            }
        }
    `);
                  
    const [showInfo, setShowInfo] = useState(false)
    const [introCopy , setIntroCopy] = useState();
    const title = h1 ? _.upperFirst(h1) : '';
    var firstIntro = `Discover a wide range of ${h1} with tlc estate agents. To filter these results, use our filter above, or for more information about sales property ${search_area}, please <Link to="/contact/">contact us</Link>.`
    const location = useLocation();  
    const currentPathname = location.pathname;
    console.log("currentPathname", currentPathname);
  

    /* dynamic intro copy function */ 
 
    const getIntroCopy = (currentPathname) => {
     const normalizePath = (path) => {
            if (!path) return "";
            return path
                .toLowerCase()
                .replace(/\/+$/, "")   // remove trailing slash
                .replace(/^\//, "");   // remove leading slash (optional depending on how you save in Strapi)
            };
        const normalizedPath = normalizePath(currentPathname);
        const introDetails = data?.glstrapi?.siteConfig?.Search_Intro?.find((item) => {
            return normalizePath(item?.Slug) === normalizedPath;
       });
      
        if (introDetails) {
            setIntroCopy(introDetails?.Intro_Content);
        } else {
            setIntroCopy(firstIntro);
        }
    };

    return (
        <div className="search-heading">
            <h1>{title} · {nbHits}
                {/* <i className="icon-info" onClick={() => setShowInfo(!showInfo)}></i> */}
                <i className="icon-info" onClick={() => {
                   setShowInfo(!showInfo); 
                   getIntroCopy(currentPathname);   
               }}>

                </i>
            </h1>

            {showInfo && introCopy &&
              <p>{HTMLReactParser(introCopy)}</p>
             }
            <span className="h1 h2">The stars of <span> our show</span> </span>
            {/* <h1 className="h2">{h1} · {nbHits}</h1>
            <p>Find your <span>next home</span> with us</p> */}
        </div>
    )
})

const CustomSortBy = connectSortBy(({ refine, index_name }) => {
    const [sortItem, setSortItem] = useState(false);
    const sortingList = () => {
        setSortItem(!sortItem);
        if (sortItem) {
            //refine(index_name + "_price_desc")
            refine(index_name)
        } else {
            refine(index_name + "_price_asc")
        }
    }
    return (
        <button type="button" onClick={sortingList} className={`btn btn-sort ${sortItem ? 'highest' : ''}`} ><i className="icon-sort"></i></button>
    )
})

const FilterOption = (props) => {
    const [open, setOpen] = useState(false);
    const showFilter = () => {
        setOpen(!open);
    };
    console.log('mk', props)
    const [bedrooms, setBedrooms] = useState('bedrooms');
    const [minprice, setMinprice] = useState('min price');
    const [maxprice, setMaxprice] = useState('max price');
    const [propertytype, setPropertyType] = useState('property type');

    const minPriceOpts = props.searchType == "sales" ? priceminRangeSale : priceminRangeRent;
    const maxPriceOpts = props.searchType == "sales" ? pricemaxRangeSale : pricemaxRangeRent;
 
    React.useEffect(() => {
        if (props.bedroom != "") {
            let val = bedroomOpts.filter(c => c.value == props.bedroom)[0].label;
            setBedrooms(val)
        }
        if (props.minPrice != "") {
            let val = minPriceOpts.filter(c => c.value == props.minPrice)[0].label;
            setMinprice(val)
        }
        if (props.maxPrice != "") {
            let val = maxPriceOpts.filter(c => c.value == props.maxPrice)[0].label;
            setMaxprice(val)
        }
        if (props.propertyType != "") {
            let val = propertyTypeOpts.filter(c => c.value == props.propertyType)[0].label;
            setPropertyType(val)
        }
    }, [props.bedroom, props.minPrice, props.maxPrice, props.propertyType])

    const minpriceSelect = (l, e) => {
        setMinprice(minPriceOpts.filter(c => c.value == l)[0].label);
        props.setMinprice(l);
    }
    const maxpriceSelect = (l, e) => {
        setMaxprice(maxPriceOpts.filter(c => c.value == l)[0].label);
        props.setMaxprice(l);
    }
    const bedroomsSelect = (l, e) => {
        setBedrooms(bedroomOpts.filter(c => c.value == l)[0].label);
        props.setBedrooms(l);
    }
    const propertyTypeSelect = (l, e) => {
        setPropertyType(propertyTypeOpts.filter(c => c.value == l)[0].label);
        props.setPropertyType(l);
    }
    const getLabel = (arr, val) => {
        return arr.filter(c => c.value == val)[0].label;
    }

    //console.log("searchString", props.searchString, props.location)
    return (
        <React.Fragment>
            <div className="filter-option">
                <Container>
                    <Row>
                        <Col>
                            <TitleContainer
                                searchType={props.searchType}
                                searchString={props.query}
                                h1={props.h1}
                                search_area={props.search_area}
                            />
                        </Col>
                    </Row>
                </Container>
                <Container className="">
                    <Row>
                        <Col>
                            <div className="filter-block">
                                <Form className="filter-form" onSubmit={e => { e.preventDefault(); props.handleSubmit() }}>
                                    <div className="filter-row">
                                        <Form.Group className="search-input">
                                            <Form.Control
                                                type="text"
                                                value={props.searchString}
                                                onChange={(e) => props.setSearchString(e.target.value.toLowerCase())}
                                                placeholder="Location or keyword"
                                                className="d-none d-md-block"
                                            />
                                            <span className="close-btm" onClick={() => props.setSearchString("")}><i className="icon-dark-close"></i></span>
                                        </Form.Group>
                                        <div className="input-wrap">
                                            <div className="input-group">
                                                <Dropdown onSelect={bedroomsSelect} className="select-option" placement="bottom">
                                                    <Dropdown.Toggle id="bedrooms">
                                                        {bedrooms}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {bedroomOpts.map(each =>
                                                            <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                <Dropdown onSelect={minpriceSelect} className="select-option" placement="bottom">
                                                    <Dropdown.Toggle id="minprice">
                                                        {minprice}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {minPriceOpts.map(each =>
                                                            <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                <Dropdown onSelect={maxpriceSelect} className="select-option">
                                                    <Dropdown.Toggle id="maxprice">
                                                        {maxprice}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {maxPriceOpts.map(each =>
                                                            <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                <Dropdown onSelect={propertyTypeSelect} className="select-option">
                                                    <Dropdown.Toggle id="propertytype">
                                                        {propertytype}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {propertyTypeOpts.map(each =>
                                                            <Dropdown.Item className="cursor-pointer" eventKey={each.value}>{each.label}</Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            <button type="button" className="filter-btn btn d-lg-none" onClick={showFilter}><i className="icon-filter"></i> <span className="d-md-none"> filter results</span> <span className="d-none d-md-block"> filters</span> </button>
                                            <button type="button" onClick={props.handleSubmit} className="search-btn btn d-none d-md-block">search</button>
                                        </div>
                                    </div>
                                    <div className="filter-btn-group">
                                        <button className={`btn ${props.listView ? "btn-active" : ""}`}
                                         onClick={() => {
                                            props.setListView(true)
                                            sessionStorage.setItem('searchindexList', true)
                                        }}
                                         ><i className="icon-list-view"></i></button>
                                        <button className={`btn ${!props.listView ? "btn-active" : ""}`}
                                           onClick={() => {
                                            props.setListView(false)
                                            sessionStorage.setItem('searchindexList', false)
                                        }}
                                        ><i className="icon-grid-view"></i></button>
                                        <CustomSortBy
                                            //defaultRefinement={props.index_name + "_price_desc"}
                                            defaultRefinement={props.index_name}
                                            index_name={props.index_name}
                                            items={[
                                                { value: props.index_name, label: "Highest Price" },
                                                { value: props.index_name + "_price_asc", label: "Lowest Price" },
                                            ]}
                                        />
                                        {/* <button type="button" onClick={sortingList} className={`btn btn-sort ${sortItem ? 'highest':''}`} ><i className="icon-sort"></i></button> */}
                                    </div>
                                </Form>
                                {props.searchType === "sales" &&
                                    <div className="includesold">
                                        <Form.Group controlId="local-news">
                                            <Form.Check
                                                type="checkbox"
                                                id="disabledFieldsetCheck"
                                                onChange={(e) => {
                                                    props.includeSold(e.target.checked);

                                                }}
                                                label="Include Sold"
                                            />
                                        </Form.Group>
                                    </div>
                                }

                            </div>


                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={open ? "filter filter-open" : "filter"} style={{ zIndex: 9999 }}>
                <Filter
                    showHide={showFilter}
                    bedrooms={bedrooms}
                    minprice={minprice}
                    maxprice={maxprice}
                    propertytype={propertytype}
                    handleSubmit={(e) => {
                        props.handleSubmit(e);
                        setOpen(false);
                    }}
                    setSearchString={(e) => {
                        props.setSearchString(e);
                    }}
                    bedroomsSelect={bedroomsSelect}
                    minpriceSelect={minpriceSelect}
                    maxpriceSelect={maxpriceSelect}
                    propertyTypeSelect={propertyTypeSelect}
                    bedroomOpts={bedroomOpts}
                    maxPriceOpts={minPriceOpts}
                    minPriceOpts={maxPriceOpts}
                    propertyTypeOpts={propertyTypeOpts}
                />
            </div>

        </React.Fragment >
    )
}

export default FilterOption;

